import NodeCache from "node-cache";

export const featureCache = new NodeCache();
